var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { node } from "prop-types";
import { MenuItem } from "#library/components/Menu/MenuItem";
import { MenuBarItem } from "#library/components/MenuBar/Item/MenuBarItem";
export var MenuBarLink = function MenuBarLink(_ref) {
  var children = _ref.children,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MenuBarItem, null, /*#__PURE__*/React.createElement(MenuItem, restProps, children));
};
MenuBarLink.propTypes = {
  children: node.isRequired
};